import { Wrench } from "lucide-react";
import { Link } from "react-router-dom";
import { pasangCopy } from "@kanata/shared";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

interface PasangToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * The installation choice.
 *
 * Off by default, because a technician has to be confirmed over WhatsApp first
 * and the fee depends on the zone (the page shows that notice, with the zone
 * estimates, when it is ticked). The fee is agreed later and never added to
 * the order total.
 */
export function PasangToggle({ checked, onChange, disabled, className }: PasangToggleProps) {
  return (
    <div
      className={cn(
        "rounded-2xl border p-4 transition-colors",
        checked ? "border-primary/40 bg-brand-tint" : "border-ink/12 bg-white",
        className,
      )}
    >
      <div className="flex gap-3">
        <Checkbox
          id="pasang"
          checked={checked}
          onCheckedChange={(v) => onChange(v === true)}
          disabled={disabled}
          className="mt-0.5"
        />
        <div className="flex-1">
          <label htmlFor="pasang" className="flex cursor-pointer items-center gap-2 font-medium text-ink">
            <Wrench className="size-4 text-brand" />
            {pasangCopy.label}
            <span className="rounded-full bg-brand-light px-2 py-0.5 text-xs font-medium text-brand-dark">
              {pasangCopy.fee}
            </span>
          </label>
          <p className="mt-1.5 text-sm leading-relaxed text-ink/65">
            {pasangCopy.description}
          </p>
          {!checked && (
            <p className="mt-2 text-sm leading-relaxed text-ink/65">
              Kamu pilih rakit sendiri. Panduan lengkap dengan foto tiap langkah ada di{" "}
              <Link to="/perakitan" className="font-medium text-brand underline underline-offset-2">
                halaman Perakitan
              </Link>
              .
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
